import React from 'react'
import styles from './styles.scss'

const MobileBuyingStyles = () => (
  // styled-jsx 2 requires a parent element to compile an external style tag.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <React.Fragment>
    <style jsx>{styles}</style>
  </React.Fragment>
)

export default MobileBuyingStyles
